module.exports = __webpack_public_path__ + "img/logo-cotizacion.30139653.png";